<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{ params?: { data?: any } }>()
const router = useRouter()

const orderUuid = computed(() => props.params?.data?.order?.uuid ?? null)
const text = computed(() => props.params?.data?.order?.quote?.quoteReference ?? '-')

function onClick(e: MouseEvent) {
  if (!orderUuid.value) return
  e.preventDefault()
  if (e.ctrlKey || e.metaKey) {
    window.open(`/dashboard/order/${orderUuid.value}`, '_blank')
  } else {
    router.push(`/dashboard/order/${orderUuid.value}`)
  }
}
</script>

<template>
  <a
    v-if="orderUuid"
    :href="`/dashboard/order/${orderUuid}`"
    class="link link-primary hover:underline"
    @click="onClick"
  >{{ text }}</a>
  <span v-else>{{ text }}</span>
</template>
